<template>
  <div>
    <v-list-item class="text-left mx-2" flat v-if="isAddressSelected">
      <v-list-item-content three-line>
        <v-list-item-title class="subtitle-2" v-if="user">
          <span class="font-weight-bold">Recibe:</span>
          <span>&nbsp;{{ user.first_name }} {{ user.last_name }}</span>
        </v-list-item-title>
        <v-list-item-title class="subtitle-2">{{ deliveryAddress.city.name }}, {{ deliveryAddress.region.name }}</v-list-item-title>
        <v-list-item-subtitle class="subtitle-2">
        <span>{{ deliveryAddress.address }}</span>
        <span v-if="!!deliveryAddress.additional_address"> {{ deliveryAddress.additional_address }},</span>
        <span> {{ deliveryAddress.neighborhood }}</span>
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action class="text-right">
        <a class="subtitle-2 blue--text link" @click="changeAddress" v-if="$vuetify.breakpoint.mdAndUp">
          <span v-if="this.isAuthenticated">Cambiar</span>
          <span v-else>Modificar</span>
        </a>
        <v-btn class="mr-n10" icon @click="changeAddress" v-else>
          <v-icon color="blue">chevron_right</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>

    <address-list v-else-if="isListView"
      :selectedAddress="deliveryAddress"
      @edit="editAddress"
      @select="selectAddress"
      @add="setAddressHandler('form')"
      @openModal="openModal"
    />

    <address-form v-else-if="isFormView"
      action="Usar esta dirección"
      :address="modifyAddress"
      :supportLocalSave="!this.isAuthenticated"
      :showCancel="true"
      @cancel="cancelAddress"
      @save="selectAddress"
    >
      <template v-slot:user v-if="user">
        <v-col xl="6" lg="6" md="6" sm="6" cols="12">
          <v-text-field class="mt-n4" v-model="user.first_name"
            label="Nombre"
            hint="Requerido"
            :rules="[isRequired]"
            persistent-hint
            solo
            dese>
          </v-text-field>
        </v-col>
        <v-col xl="6" lg="6" md="6" sm="6" cols="12">
          <v-text-field class="mt-n4" v-model="user.last_name"
            label="Apellidos"
            hint="Requerido"
            :rules="[isRequired]"
            persistent-hint
            solo
            dese>
          </v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field class="mt-n4" v-model="user.email"
            label="Correo"
            hint="Requerido"
            :rules="[isRequired, isEmail]"
            persistent-hint
            solo
            dese>
          </v-text-field>
        </v-col>
      </template>
    </address-form>

    <delivery-type v-if="showDeliveryTypes" />

    <address-modal ref="addressmodal"
      :address="modifyAddress"
      :supportLocalSave="!this.isAuthenticated"
      @close="modalClosed"
      @save="selectAddress"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { getErrorMessage } from '@/shared/errors'
import AddressList from '@/components/Address/AddressList'
import AddressForm from '@/components/Address/AddressForm'
import AddressModal from '@/components/Address/AddressModal'
import DeliveryType from '@/components/Checkout/DeliveryType'
import { isRequired, isEmail } from '@/shared/validations'
import { tokenToJSON } from '@/shared/token'

export default {
  components: {
    AddressList,
    AddressForm,
    AddressModal,
    DeliveryType
  },
  data () {
    return {
      isRequired,
      isEmail,
      addressHandler: 'list',
      modifyAddress: undefined,
      deliveryTypesError: ''
    }
  },
  computed: {
    ...mapState('shared', ['error', 'loading']),
    ...mapState('auth', ['isAuthenticated']),
    ...mapState('cart', ['deliveryAddress', 'user']),
    ...mapState('shipping', ['deliveryTypes']),
    ...mapState('user', ['_user']),
    ...mapGetters('cart', ['totalCost']),
    isFormView () {
      return this.addressHandler === 'form'
    },
    isListView () {
      return this.addressHandler === 'list'
    },
    isAddressSelected () {
      return this.addressHandler === 'selected'
    },
    showDeliveryTypes () {
      return !!this.deliveryTypes && this.deliveryTypes.length > 0 && this.addressHandler === 'selected'
    }
  },
  methods: {
    ...mapMutations('cart', ['setDeliveryAddress', 'setDeliveryType', 'setUser']),
    ...mapActions('shipping', ['getDeliveryTypes']),
    ...mapActions('user', ['getUser']),
    setAddressHandler (value) {
      this.addressHandler = value
    },
    changeAddress () {
      if (this.isAuthenticated) {
        this.setAddressHandler('list')
        return
      }

      if (this.$vuetify.breakpoint.smAndDown) {
        this.openModal(this.deliveryAddress)
        return
      }

      this.modifyAddress = this.deliveryAddress
      this.setAddressHandler('form')
    },
    editAddress (address) {
      this.modifyAddress = address
      this.setAddressHandler('form')
    },
    cancelAddress () {
      const value = this.deliveryAddress ? 'selected' : 'list'
      this.setAddressHandler(value)
    },
    async selectAddress (address) {
      await this.getDeliveryTypes({ cityID: address.city.code, totalValue: this.totalCost })
      if (this.error) {
        this.setDeliveryAddress(null)
        this.$emit('notificationPopup', { icon: 'error', color: 'error', message: getErrorMessage('delivery_address', this.error) })
        return
      }

      this.setUser(this.user)
      this.setDeliveryAddress(address)
      this.modifyAddress = undefined
      this.setDeliveryType(null)
      this.setAddressHandler('selected')
    },
    modalClosed () {
      this.modifyAddress = undefined
    },
    openModal (address) {
      this.modifyAddress = address
      this.$refs.addressmodal.openModal()
    }
  },
  async mounted () {
    if (!this.user) {
      this.setUser({})
    }

    if (!this.deliveryAddress) {
      return
    }

    const jsonToken = tokenToJSON()
    if (jsonToken && jsonToken.user_id) {
      await this.getUser(jsonToken.user_id)
      this.setUser(this._user)
    }

    await this.getDeliveryTypes({ cityID: this.deliveryAddress.city.code, totalValue: this.totalCost })
    if (this.error) {
      this.setDeliveryAddress(null)
      this.setAddressHandler('list')
      return
    }

    this.setAddressHandler('selected')
  }
}
</script>

<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';
  .border-top{
    border-top: 1px solid;
    border-color: rgba(0, 0, 0, 0.12);
  }
</style>
